const validEmailCheck = (email) => {
	let isValid = true;
	const validEmail = /^\S+@\S+\.\S+$/;

	!email.match(validEmail) ? (isValid = false) : (isValid = true);

	return isValid;
};

export default validEmailCheck;
